'use strict';
var $ = require('jquery');
var Masonry = require('masonry-layout');


// Constructor
var CardFault = function() {
};

function progressHeight() {
    $('.card-fault').each(function () {
        var overviewHeight = $(this).find('.card-fault__overview').height();
        var progress = $(this).find('.card-fault__progress');
        progress.css('height', overviewHeight).show();
        progress.find('progress').css('height', overviewHeight);
    });

    $('.card-fault a.dynamics').on('click touchstart', function () {
        resetModal();
        var parentCard = $(this).closest('.card-fault');
        parentCard.addClass('selected');
        $('body').addClass('show-dynamics');
        $('html').css('overflow', 'hidden');
        populateModal(parentCard);
    });

    $('.card-fault a.card-fault__fault-fixes').on('click touchstart', function () {
        $('body').addClass('show-kbs');
        $('html').css('overflow', 'hidden');
    });
}

function populateModal(parentCard) {
    var moduleInfoDiv = $('.dynamics-modal__module-info');

    moduleInfoDiv.find('h3').text(parentCard.find('h3').text());
    moduleInfoDiv.find('h4').html(parentCard.find('.card-fault__highlight').html());
    moduleInfoDiv.find('.dynamic-modal__module-faults').html(parentCard.find('.card-fault__faults').html());

    $('.dynamic-modal__module-faults a.card-fault__fault-fixes').on('click touchstart', function () {
        $('body').addClass('show-kbs');
        $('html').css('overflow', 'hidden');
    });
}

function resetModal() {
    $('.dynamics-modal__selected-dynamics .dynamic-visual').remove();
    $('.dynamics-modal__selected-dynamics h2').show();
    $('.dynamics-modal__available-dynamics .dynamic.selected').removeClass('selected');
}

function masonryLayout() {
    var msnry = new Masonry('.scan-page .modules', {
        itemSelector: '.scan-module',
        percentPosition: true,
        isAnimated: true,
        transitionDuration: 0,
        animationOptions: {
            duration: 500,
            easing: 'linear',
            queue: true
        }
    });
}

CardFault.init = function () {

    if (!$('body#scan').length) {
        return true;
    }

    $( window ).resize(function () {
        masonryLayout();
        progressHeight();
    });

    $( window ).load(function () {
        masonryLayout();
        progressHeight();
    });

    $('.card-fault.success, .card-fault.error, .card-fault.warning, .card-fault.group-toggle').on('click touchstart', function (e) {
        if (!$(this).find('.card-fault__content').length) {
            return true;
        }
        var target  = $(e.target);
        if( target.is('a') || target.is('span.link-text') ) {
            return true;
        }
        $(this).toggleClass('open');
        $(this).find('.card-fault__content').slideToggle('fast').promise().done(function () {
            masonryLayout();
        });
    });
};

module.exports = CardFault;
